// Basado en https://gist.github.com/saqueib/a495af17d7c0e2fd5c2316b0822ebac3
//Devuelve una función para usar como interceptor de axios
export function useErrorHandler(showErrorCallback) {
  return (error) => {
    // Se puede desactivar poniendo axios.get('/user/1', {errorHandle: false})
    if (error.config.hasOwnProperty('errorHandle') && error.config.errorHandle === false) {
      return Promise.reject(error);
    }

    // if has response show the error
    const json = error.response.data;
    if (json.error) {
      if (json.error.type === 'model_errors') {
        showErrorCallback({
          message: json.data.full_messages.join('\n'),
          error: json.error
        });
      } else {
        showErrorCallback({
          message: json.error.message,
          error: json.error
        });
      }
    }
    return Promise.reject(error);
  }
}


export function useErrorHandlerWithVueToast(vue) {
  return useErrorHandler(( { message }) => {
    vue.$toast.error(message, { timeout: 3000 });
  })
}

export default {
  useErrorHandler, useErrorHandlerWithVueToast
}
